/**
 * Forgot / reset-password form contracts — self-service credential recovery.
 *
 * The flow mirrors the TW-3436 invite/first-login pattern (a single-use, time-boxed token in
 * Better Auth's `verification` table, emailed as a link, consumed when the user picks a new
 * password). What lives here is only the framework-free *shape* the web forms and the server's
 * `ZodValidationPipe` share:
 *   • the request step takes an email address;
 *   • the reset step takes a new password, with the same `min(8).max(128)` rule as
 *     `acceptInviteSchema` (setting a fresh password is the same operation).
 *
 * Leaf module: no sibling imports, so the barrel never forms a cycle (see index.ts).
 */
import { z } from "zod";

/** "Forgot password?" — the email a user asks the reset link to be sent to. */
export const requestPasswordResetSchema = z.object({
  email: z.email(),
});
export type RequestPasswordResetInput = z.infer<typeof requestPasswordResetSchema>;

/** The new password chosen on the reset page (same rule as invite set-password). */
export const resetPasswordSchema = z.object({
  password: z.string().min(8).max(128),
});
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
